import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import RootRef from '@material-ui/core/RootRef';
import GridViewImage from './Image';

var getVal = function getVal(item, config, fn) {
  var out = '';
  if (typeof fn === 'function') out = fn(item, config);else if (typeof fn === 'string') out = fn;else if (!fn) out = '';
  return out;
};
/**
 * @extends {React.Component<import('./types').GridViewThumbnailItemProps> }
 */


var GridViewThumbnailItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GridViewThumbnailItem, _React$Component);

  function GridViewThumbnailItem() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, GridViewThumbnailItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(GridViewThumbnailItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      hovered: false
    };
    _this.rootRef = React.createRef();

    _this.onClick = function (e) {
      if (_this.props.onClick) _this.props.onClick(e, _this.props.item);
    };

    _this.onDoubleClick = function (e) {
      if (_this.props.onDoubleClick) _this.props.onDoubleClick(e, _this.props.item);
    };

    _this.onContextMenu = function (e, info) {
      if (_this.props.onContextMenu) {
        e.stopPropagation();

        _this.props.onContextMenu(e, _this.props.item, info);
      }
    };

    _this.handleMouseEnter = function () {
      _this.setState({
        hovered: true
      });
    };

    _this.handleMouseOver = function () {
      _this.setState({
        hovered: true
      });
    };

    _this.handleMouseLeave = function () {
      _this.setState({
        hovered: false
      });
    };

    _this.isSelected = function (p) {
      var props = p ? p : _this.props;
      var isSelected = props.item ? props.item[props.config.selectedKeyProp || '_selected'] : false;
      if (!isSelected && props.selected === true) isSelected = true;
      return isSelected;
    };

    return _this;
  }

  _createClass(GridViewThumbnailItem, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.isSelected() && !this.isSelected(prevProps)) this.rootRef.current.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          config = _this$props.config,
          item = _this$props.item,
          rest = _objectWithoutProperties(_this$props, ["config", "item"]);

      if (!item) return null;
      var url = getVal(item, config, config.thumbnail.url);
      var icon = getVal(item, config, config.thumbnail.icon);
      var text = getVal(item, config, config.thumbnail.text);
      var style = getVal(item, config, config.thumbnail.style) || {};
      var isSelected = this.isSelected();
      var Wrapper = React.Fragment;
      var wrapperProps = {};
      if (config.thumbnail.component) Wrapper = config.thumbnail.component;
      if (config.thumbnail.componentProps) wrapperProps = getVal(item, config, config.thumbnail.componentProps);
      return React.createElement(Wrapper, wrapperProps, React.createElement(RootRef, {
        rootRef: this.rootRef
      }, React.createElement(GridViewImage, Object.assign({
        onMouseEnter: this.handleMouseEnter,
        onMouseOver: this.handleMouseOver,
        onMouseLeave: this.handleMouseLeave,
        tabIndex: isSelected ? 0 : -1
      }, rest, {
        url: url,
        icon: icon,
        text: text,
        style: style,
        selected: isSelected,
        hovered: this.state.hovered,
        deleted: item && item.__deleting,
        updating: item && item.__updating,
        onClick: this.onClick,
        onDoubleClick: this.onDoubleClick,
        onContextMenu: this.onContextMenu
      }))));
    }
  }]);

  return GridViewThumbnailItem;
}(React.Component);

GridViewThumbnailItem.defaultProps = {
  selected: false
};
export default GridViewThumbnailItem;